const GarifunaPhrases = [
    {
        id: 1,
        garifuna: 'Mábuiga' ,
        translation: 'Hello',
    },
    {
        id: 2,
        garifuna: 'Buíti binafi' ,
        translation: 'Good morning',
    },
    {
        id: 3,
        garifuna: 'Buíti amidi' ,
        translation: 'Good afternoon',
    },
    {
        id: 4,
        garifuna: 'Buíti ranbá weyu' ,
        translation: 'Good evening',
    },
    {
        id: 5,
        garifuna: 'Buíti gúyoun' ,
        translation: 'Good night',
    },
    {
        id: 6,
        garifuna: 'Ayóu' ,
        translation: 'Goodbye',
    },
    {
        id: 7,
        garifuna: 'Seremei' ,
        translation: 'Thank you',
    },
    {
        id: 8,
        garifuna: 'Úwati mégeiti' ,
        translation: 'You are welcome',
    },
    {
        id: 9,
        garifuna: 'Belú' ,
        translation: 'Come in (to the house, used in place of "Welcome")',
    },
    {
        id: 10,
        garifuna: 'Bungíu bún' ,
        translation: 'God bless you',
    },
]

export default GarifunaPhrases;
